import { ICreatorInsights } from "@shared/lib/types/influencer";

export const CREATOR_SCRIPT_JOB_STATUS = {
  waitingCreatorProfile: "waiting_creator_profile",
  waitingUserInputs: "waiting_user_inputs",
  conceptualising: "conceptualising",
  conceptualised: "conceptualised",
  failed: "failed",
  ready: "ready",
} as const;

export type CreatorScriptJobStatus =
  (typeof CREATOR_SCRIPT_JOB_STATUS)[keyof typeof CREATOR_SCRIPT_JOB_STATUS];

export interface ICreatorScriptUserInputs {
  brief: string;
  format: string;
  duration: string;
  toneBalance: string;
  language: string;
  submittedAt?: string;
}

export interface IScriptConcept {
  _id: string;
  title: string;
  summary: string;
  hook: string;
  beats: string[];
}

export enum IAiScriptStatus {
  waitingCreatorProfile = "waiting_creator_profile",
  waitingUserInputs = "waiting_user_inputs",
  conceptualising = "conceptualising",
  conceptualised = "conceptualised",
  ready = "ready",
  failed = "failed",
}

export interface ICreatorScriptGeneratorJobDetail {
  _id: string;
  id: string;
  socialMediaObjectId: string;
  platform: string;
  username: string;
  status: IAiScriptStatus;
  prerequisites?: {
    creatorProfile?: string;
    creatorProfileJob?: string;
  };
  createdBy?: string;
  createdByModelName?: string;
  createdByType?: string;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
  creatorProfileId?: string;
  creatorProfileVersion?: number;
  creatorProfileJobId?: string;
  userInputs?: ICreatorScriptUserInputs;
  scriptConceptId?: string;
  concepts?: IScriptConcept[];
  script?: string;
  creatorProfile?: {
    _id?: string;
    aiAnalysis?: ICreatorInsights;
  };
}

export interface ISaveCreatorScriptPayload {
  creatorScriptGeneratorJobId: string;
  script: string;
}

export interface ICreatorScriptUserInputsPayload {
  brief: string;
  format: string;
  duration: string;
  toneBalance: string;
  language: string;
}

export interface IUpdateScriptGenerationMasterPromptPayload
  extends ICreatorScriptUserInputsPayload {
  aiWorkspaceId: string;
}

export interface IConceptualiseCreatorScriptPayload {
  creatorScriptGeneratorJobId: string;
  userInputs: ICreatorScriptUserInputsPayload;
}
